import {
    Box,
    Flex,
    FormControl,
    FormLabel,
    Input,
    InputGroup,
    InputRightElement,
    SimpleGrid,
    Text,
    useClipboard,
} from '@chakra-ui/react';
import { isEqual } from 'lodash';

import { CopyBlueIcon } from '@assets/icons/index';
import { ConditionalComponent } from '@components/functionComponent';
import Select from '@components/filter/select';
import useGetChannelReport from '../../hooks/query/useGetChannelReport';
import { useSnackbarNotification } from '@store/snackbarNotification';
import { initialChannelReport, useCustomerDetail } from '@pages/Parahub/hooks/state/useCustomerDetail';
import { WarningIcon } from '@assets/icons';

export default function CustomerDetail({ custDetail }) {
    const { initialData, formData, updateFields } = useCustomerDetail();
    const { onCopy, setValue } = useClipboard('');
    const { onChangeSnackbarNotification } = useSnackbarNotification();

    const { data, isLoading, refetch } = useGetChannelReport();

    const handleCopy = (val) => {
        setValue(val);
        onCopy();
        onChangeSnackbarNotification({
            status: 'success',
            description: `Customer ID Berhasil di salin!`,
            duration: 3,
        });
    };

    const renderInput = ({ label, value, isRequired, idx }) => (
        <Box key={idx} mb="8px">
            <FormControl isRequired={isRequired}>
                <FormLabel as={Text} fontSize="14px" fontWeight={700}>
                    {label}
                </FormLabel>

                <InputGroup>
                    <Input
                        value={value}
                        disabled={idx === 0 || idx === 3}
                        onChange={
                            idx === 1 ? (e) => updateFields({ customer_parahub_name: e.target.value }) : undefined
                        }
                    />
                    <ConditionalComponent statement={idx === 0}>
                        <InputRightElement>
                            <CopyBlueIcon onClick={() => handleCopy(value)} />
                        </InputRightElement>
                    </ConditionalComponent>
                </InputGroup>
            </FormControl>
        </Box>
    );

    return (
        <Box>
            <SimpleGrid columns={4} spacing="24px">
                {custDetail.map(({ label, value, isRequired }, idx) => {
                    if (idx === 2) {
                        const isWarning = isEqual(formData?.channel, initialChannelReport.name);
                        const title = isWarning ? (
                            <Flex justifyContent="space-between" alignItems="center">
                                {label}
                                <WarningIcon />
                            </Flex>
                        ) : (
                            label
                        );

                        return (
                            <Box key={idx} mb="8px">
                                <Select
                                    selected={{ id: formData?.channel_report_id, name: formData?.channel }}
                                    title={title}
                                    isMultiple={false}
                                    refetchData={refetch}
                                    data={data}
                                    isLoading={isLoading}
                                    onChangeFilter={(value) => {
                                        updateFields({
                                            channel: value.name,
                                            channel_report_id: value.id,
                                        });
                                    }}
                                    onCloseOptions={() => {
                                        updateFields({
                                            channel: initialData?.channel,
                                            channel_report_id: initialData?.channel_report_id,
                                        });
                                    }}
                                />
                            </Box>
                        );
                    }

                    return renderInput({ label, value, isRequired, idx });
                })}
            </SimpleGrid>
        </Box>
    );
}
